module.exports = "/static/assets/d290a2f6958b222711fb4d56966c3978.png";